import React from 'react';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import type { ReportsCompanyLookup } from './reportsCompaniesLookupMapper';
import { mapCompanyToReportsLookup } from './reportsCompaniesLookupMapper';

export const useGetReportsCompaniesLookupQuery = (): {
  companies: ReportsCompanyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetCompaniesQuery();

  const companies = React.useMemo(
    (): ReportsCompanyLookup[] =>
      (data ?? [])
        .map(mapCompanyToReportsLookup)
        .filter((item): item is ReportsCompanyLookup => item !== undefined)
        .sort((a, b) => a.name.localeCompare(b.name, 'pl')),
    [data]
  );

  return {
    companies,
    isLoading,
  };
};
